module.exports = __webpack_public_path__ + "static/035-b22bc282659e933e6515206efb3338bd.jpg";